<template>
  <v-main class="blue-grey lighten-4">
    <v-container
      fluid
      style="
         {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
        }
      "
    >
      <slot />
    </v-container>
  </v-main>
</template>

<script>

export default {
  name: 'LayoutPublic'
}
</script>
